import React, { useMemo, useState } from "react";
import { Box, Text } from "@chakra-ui/react";

// Giải mã entity (mô tả trong DB bị mã hoá &lt; &gt; ...), có thể 2 lớp
const decode = (s) => {
  let out = String(s || "");
  for (let i = 0; i < 2; i++) {
    out = out
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&amp;/gi, "&")
      .replace(/&nbsp;/gi, " ")
      .replace(/&#39;/g, "'")
      .replace(/&quot;/gi, '"');
  }
  return out;
};

// Làm sạch HTML: bỏ script/style, bỏ on*=handlers, chặn javascript:, link mở tab mới
const sanitize = (html) => {
  let s = decode(html);
  s = s.replace(/<\s*(script|style)[\s\S]*?<\/\s*\1\s*>/gi, " ");
  s = s.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  s = s.replace(/javascript:/gi, "");
  s = s.replace(/<a\s/gi, '<a target="_blank" rel="noopener noreferrer" ');
  return s;
};

const plainLen = (s) => decode(s).replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim().length;

// Mô tả giữ nguyên link + xuống dòng, có "Xem thêm / Ẩn bớt" (khớp app)
const RichDescription = ({ html }) => {
  const [open, setOpen] = useState(false);
  const clean = useMemo(() => sanitize(html), [html]);
  const long = useMemo(() => plainLen(html) > 400, [html]);
  if (!clean.replace(/<[^>]+>/g, "").trim()) return null;
  return (
    <Box>
      <Box
        fontSize="14px"
        color="#08142D"
        lineHeight="21px"
        maxH={open || !long ? "none" : "300px"}
        overflow="hidden"
        sx={{
          "& a": { color: "#4081EB", textDecoration: "underline", wordBreak: "break-word" },
          "& p": { marginBottom: "6px" },
          "& ul, & ol": { paddingLeft: "18px" },
        }}
        dangerouslySetInnerHTML={{ __html: clean }}
      />
      {long && (
        <Text as="button" type="button" mt="6px" fontSize="14px" fontWeight={600} color="#4081EB" onClick={() => setOpen((o) => !o)}>
          {open ? "Ẩn bớt" : "Xem thêm"}
        </Text>
      )}
    </Box>
  );
};

export default RichDescription;
